import React from 'react';
import '../../styles/home/TrustedSection.css';

const testimonials = [
  {
    quote: '"VIN is the only distributor we trust to deliver on time every week"',
    location: '-Louisville, KY',
  },
  {
    quote: '"The app makes ordering so simple. It saves us hours every month"',
    location: '-Lexington, KY',
  },
  {
    quote: '"Real service. Real People. A distributor that actually cares"',
    location: '-Cincinnati, OH',
  },
];

const TrustedSection: React.FC = () => {
  return (
    <section className="trusted">
      <div className="trusted__container">
        <span className="trusted__tag">PARTNER PROGRAM</span>
        <h2 className="trusted__heading">
          Trusted by Retailers Across the Region
        </h2>
        <p className="trusted__subtitle">
          What our retail partners say about working with VIN Services.
        </p>

        <div className="trusted__grid">
          {testimonials.map((t, i) => (
            <div key={i} className="trusted__card">
              <p className="trusted__card-quote">{t.quote}</p>
              <span className="trusted__card-location">{t.location}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;
